// 泰语
module.exports = {
    public: {
        confirm: 'ยืนยัน',
        cancel: 'ยกเลิก',
        reset: 'รีเซ็ต',
        search: 'ค้นหา',
        RefreshSucceeded: 'รีเฟรชสำเร็จ',
        noMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
        pullingText: 'ดึงเพื่อรีเฟรช...',
        ReleaseText: 'ปล่อยเพื่อรีเฟรช...',
        loadingText: 'กำลังโหลด...',
        noData: 'ไม่มีบันทึก',
        copyTxt: 'คัดลอก',
        copySuccess: 'คัดลอกสำเร็จ',
        amount: 'จำนวนเงิน',
        buy: 'ซื้อ',
        orderNo: 'หมายเลขคำสั่ง',
        selectLang: 'เลือกภาษา',
        light: 'โหมดสว่าง',
        dark: 'โหมดมืด',
        All: 'ทั้งหมด',
        DigitalCurrency: 'สกุลเงินดิจิทัล',
        foreignExchange: 'การแลกเปลี่ยนเงินตราต่างประเทศ',
        futures: 'ฟิวเจอร์ส',
        stockIndex: 'ดัชนีหุ้น',
        stock: 'หุ้น',
        BalanceNot: 'ยอดเงินไม่เพียงพอ',
        optional: 'เลือกเอง',
        market: 'ตลาด',
        USDTcontract: 'สัญญา USDT',
        Fiatcurrencycontract: 'สัญญาเงินตราผันผวน',
        spot: 'สปอต',
        secondContract: 'สัญญาวินาที',
        emptyTxt: 'ไม่มีบันทึก',
    },
    tabBar: {
        home: 'หน้าแรก',
        market: 'ค้นพบ',
        trade: 'การซื้อขาย',
        heel: 'การบริหารการเงิน',
        asset: 'สินทรัพย์',
    },
    about: {
        title: 'เกี่ยวกับเรา',
        version: 'เวอร์ชั่น',
        about: 'เกี่ยวกับ',
        ProductIntroduction: 'แนะนำผลิตภัณฑ์',
        Termofservice: 'ข้อกำหนดในการให้บริการ',
        PrivacyAgreement: 'ข้อตกลงความเป็นส่วนตัว',
        Riskstatement: 'คำเตือนความเสี่ยง',
        whitePaper: 'เอกสารไวท์เปเปอร์',
    },
    asset: {
        Overview: 'ภาพรวม',
        contract: 'สัญญา',
        wallet: 'กระเป๋า',
        Totalassetvaluation: 'มูลค่าทรัพย์สินรวม',
        supportswithdrawal: 'ทรัพย์สินที่คุณฝากทั้งหมดสามารถถอนออกได้',
        Recharge: 'ฝากเงิน',
        Contractaccount: 'บัญชีสัญญา',
        Spotaccount: 'บัญชีสปอต',
        Walletaccount: 'บัญชีผู้ใช้',
        ValuationContractAssets: 'มูลค่าสินทรัพย์สัญญา',
        profitloss: 'กำไร/ขาดทุน',
        Transfer: 'โอน',
        occupy: 'ล็อค',
        available: 'พร้อมใช้งาน',
        Viewallpositions: 'ดูตำแหน่งทั้งหมด',
        Valuationspotassets: 'มูลค่าสินทรัพย์สปอต',
        Hidezerobalanceassets: 'ซ่อนสินทรัพย์ที่มียอดศูนย์',
        balance: 'ยอดเงิน',
        ValuationWalletAssets: 'มูลค่าสินทรัพย์กระเป๋า',
        Withdrawal: 'ถอน',
        Walletbalance: 'ยอดกระเป๋า',
        Cryptocurrencyrecharge: 'ฝากเงินคริปโต',
        Fiatcurrencyrecharge: 'ฝากเงินสกุลเงินตราผันผวน',
        From: 'จาก',
        To: 'ถึง',
        UsdtContractaccount: 'บัญชีสัญญา USDT',
        FiatContractaccount: 'บัญชีสัญญาเงินตราผันผวน',
        Currency: 'สกุลเงิน',
        quantity: 'จำนวน',
        availablebalance: 'ยอดเงินที่พร้อมใช้งาน',
        Insufficientavailablebalance: 'ยอดเงินไม่เพียงพอ',
        Transfersuccessful: 'โอนสำเร็จ',
        flashcash: 'แลกเปลี่ยนด่วน',
        flashcashsuccessful: 'แลกเปลี่ยนด่วนสำเร็จ',
    },
    auth: {
        title: 'การตรวจสอบตัวตน',
        gj: 'สัญชาติ',
        tipsgj: 'โปรดเลือกสัญชาติ',
        userName: 'ชื่อจริง',
        tips1: 'โปรดกรอกชื่อจริง',
        IDNumber: 'หมายเลขบัตรประชาชน',
        tips2: 'โปรดกรอกหมายเลขบัตรประชาชน',
        base: 'การยืนยันระดับพื้นฐาน',
        high: 'การยืนยันระดับสูง',
        zmz: 'รูปภาพด้านหน้าเอกสาร',
        bmz: 'รูปภาพด้านหลังเอกสาร',
        tips3: 'โปรดอัปโหลดรูปภาพด้านหน้าเอกสาร',
        tips4: 'โปรดอัปโหลดรูปภาพด้านหลังเอกสาร',
        btn: 'ส่ง',
        upbtn: 'แก้ไขเอกสาร',
        subMsg: 'ส่งเรียบร้อย กรุณารอการตรวจสอบ',
        upMsg: 'หลังการแก้ไขจะต้องตรวจสอบใหม่ ยืนยันการแก้ไขเอกสาร?',
        wait: 'กำลังตรวจสอบ',
        fail: 'การยืนยันล้มเหลว',
        success: 'การยืนยันสำเร็จ',
        cardType: 'ประเภทเอกสาร',
        idCard: 'บัตรประชาชน',
        passport: 'หนังสือเดินทาง',
        driverlicense: 'ใบขับขี่',
        AssetCertification: 'การรับรองสินทรัพย์',
        AccountType: 'ประเภทบัญชี',
        holdingamount: 'จำนวนเงินที่ถือครอง',
        Accountscreenshot: 'ภาพหน้าจอบัญชี',
        bankaccount: 'บัญชีธนาคาร',
        IRAaccount: 'บัญชี IRA',
        stockaccount: 'บัญชีหุ้น',
        other: 'อื่น ๆ',
        AccountTypetips: 'กรุณาเลือกประเภทบัญชี',
        Accountscreenshottips: 'กรุณาอัปโหลดภาพหน้าจอบัญชี',
    },
    activity: {
        toptit: 'สิทธิประโยชน์',
        inviteTxt: 'เชิญเพื่อน 1 คน คุณจะได้รับ {amount} USD รองรับค่าคอมมิชชั่นได้สูงสุด 3 ระดับ',
        invitebtn: 'เชิญและรับค่าคอมมิชชั่น',
        rechargeTxt: 'เมื่อผู้อยู่ใต้สายของคุณเติมเงิน คุณจะได้รับค่าคอมมิชชั่น {amount}% รองรับได้สูงสุด 3 ระดับ',
        rechargebtn: 'ค่าคอมมิชชั่นจากการเติมเงิน',
        authTxt: 'รับ {amount} USD ทันทีเมื่อยืนยันตัวตนสำเร็จ',
        authbtn: 'ยืนยันตัวตน',
        inviteRewardTxt: '<p><strong>เชิญเพื่อน รับ 30 USD ง่ายๆ</strong></p><p><br></p><p>1. จุดประสงค์ของกิจกรรม</p><p><br></p><p>กลุ่มเป้าหมาย: ผู้ใช้ใหม่และเก่า สามารถเข้าร่วมได้ โดยกระตุ้นให้ผู้ใช้เชิญเพื่อนสมัครและดำเนินการตามเงื่อนไขเพื่อขยายฐานผู้ใช้ของแพลตฟอร์ม</p><p>แนวคิดหลัก: ใช้กลไกการแนะนำ (referral) ให้ผู้ใช้ใหม่เข้าร่วมได้อย่างรวดเร็วและสร้างการเติบโตแบบไวรัล พร้อมมอบรางวัลจริงแก่ผู้แนะนำ เพื่อเพิ่มการยึดติดและความภักดีของผู้ใช้</p><p><br></p><p>2. ระยะเวลากิจกรรม</p><p><br></p><p>20/05/2023 – มีผลตลอดไป (อาจปรับตรวจสอบหรือสิ้นสุดตามประกาศ)</p><p><br></p><p>3. สำหรับผู้เข้าร่วม</p><p><br></p><p>ผู้ใช้ที่ลงทะเบียนและยืนยันตัวตนขั้นพื้นฐานเรียบร้อยแล้ว สามารถเป็นผู้แนะนำ (A) ได้</p><p>ผู้ถูกเชิญ (B) ต้องลงทะเบียนใหม่ผ่านลิงก์หรือโค้ดเชิญและยืนยันตัวตนจึงถือว่าสมบูรณ์</p><p><br></p><p>4. กติกาการเข้าร่วม</p><p><br></p><p>วิธีเชิญ:</p><p>ผู้แนะนำ (A) เข้า “หน้าบุคคล” → “เชิญเพื่อน” → คัดลอกลิงก์/โค้ดเชิญของตน</p><p>แชร์ให้เพื่อน (B) ลงทะเบียนผ่านเว็บไซต์หรือแอป</p><p><br></p><p>เงื่อนไขสำหรับผู้ถูกเชิญ:</p><p>B ต้องใช้ลิงก์หรือโค้ดของ A ในการลงทะเบียนครั้งแรก</p><p>ภายใน 7 วัน ต้องยืนยันตัวตนและฝากเงินขั้นต่ำ (เช่น ฝากครั้งแรก ≥ 1000 USD หรือเทียบเท่า)</p><p><br></p><p>ระบบระดับ:</p><p>โปรแกรมรองรับคอมมิชชั่นสูงสุด 3 ระดับ</p><p>ระดับ 1 (เชิญตรง): A เชิญ B โดยตรง</p><p>ระดับ 2: B เชิญ C → A ได้คอมมิชชั่นระดับ 2</p><p>ระดับ 3: C เชิญ D → A ได้คอมมิชชั่นระดับ 3</p><p>เกินระดับ 3 (เช่น D เชิญ E เป็นต้น) จะไม่ถูกนับสำหรับ A</p><p><br></p><p>5. รายละเอียดของรางวัล</p><p><br></p><p>รางวัลระดับ 1 (เชิญตรง):</p><p>เมื่อ B ทำการฝากและยืนยันตัวตน A จะได้รับ 30 USD</p><p><br></p><p>รางวัลระดับ 2 (เชิญทางอ้อม):</p><p>หาก B เชิญ C แล้ว C ทำตามเงื่อนไข A จะได้รับ 15 USD</p><p><br></p><p>รางวัลระดับ 3:</p><p>หาก C เชิญ D และทำตามเงื่อนไข A จะได้รับ 10 USD</p><p><br></p><p>วิธีการจ่ายรางวัล:</p><p>ระบบจะตรวจจับความสัมพันธ์ 3 ระดับโดยอัตโนมัติ เมื่อผู้ใต้สายตรงหรืออ้อมปฏิบัติตามเงื่อนไข A จะได้รับรางวัลเข้าบัญชีภายใน <strong>48 ชั่วโมง</strong></p><p><br></p><p>6. ตัวอย่างขั้นตอน:</p><p><br></p><p>A ล็อกอิน cryptorix → “หน้าบุคคล” → “เชิญเพื่อน” → คัดลอกลิงก์/โค้ด</p><p>A ส่งให้ B</p><p>B คลิกลิงก์หรือใส่โค้ด → ไปหน้าลงทะเบียน → สมัครด้วยอีเมล → ยืนยันตัวตนและฝาก ≥ 1000 USD</p><p>เมื่อ B ทำเสร็จแล้ว ติดต่อฝ่ายสนับสนุนเพื่อขอรับรางวัล ระบบจะตรวจสอบและโอน 30 USD ให้ A ภายใน 48 ชั่วโมง</p><p>หาก B เชิญ C และ C ทำตามเงื่อนไข A จะได้รับ 15 USD; หาก C เชิญ D และ D ทำตามเงื่อนไข A จะได้รับ 10 USD</p><p><br></p><p>7. การควบคุมความเสี่ยงและข้อควรระวัง</p><p><br></p><p>ป้องกันการทุจริต:</p><p>แต่ละเบอร์โทรศัพท์/อีเมลลงทะเบียนได้เพียงครั้งเดียว; IP, เอกสารยืนยัน ฯลฯ จะถูกตรวจสอบโดยระบบความเสี่ยง</p><p>สำหรับบัญชีคุณภาพต่ำหรือสมัครจำนวนมากจากอุปกรณ์/เครือข่ายเดียวกัน ระบบจะตรวจสอบด้วยตนเองและอาจยกเลิกรางวัล</p><p><br></p><p>บทลงโทษ:</p><p>หากตรวจพบการทุจริตหรือถอนเงินผิดกฎหมายผ่านระบบเชิญ แพลตฟอร์มมีสิทธิ์ยกเลิกรางวัลและระงับบัญชี</p><p><br></p>',
        rechargeRewardTxt: '<p><strong>คอมมิชชั่นจากยอดฝากของผู้ใต้สาย ได้กำไรทันที</strong></p><p><br></p><p><strong>1. จุดประสงค์ของกิจกรรม</strong></p><p><br></p><p>กลุ่มเป้าหมาย: ผู้แนะนำระดับ 1 (A) ที่ยืนยันตัวตนแล้วและมีการเชิญผู้ใช้ระดับล่าง (B, C, D); เมื่อพวกเขาฝากเงิน A จะได้รับเปอร์เซ็นต์คอมมิชชั่นตามที่แพลตฟอร์มกำหนด เพื่อส่งเสริมเครือข่ายและกิจกรรมของผู้ใช้</p><p><br></p><p>แนวคิดหลัก: ด้วยกลไก “คอมมิชชั่นจากการฝาก” เชื่อมโยงการกระทำฝากของผู้ใช้ใหม่กับผลประโยชน์ของผู้แนะนำ สร้างวงจร “เชิญ – ฝาก – รับคอมมิชชั่น – เชิญต่อ” เพื่อสนับสนุนการรักษาทุนและความเคลื่อนไหวของแพลตฟอร์ม</p><p><br></p><p><strong>2. ระยะเวลากิจกรรม</strong></p><p><br></p><p>จัดต่อเนื่องตั้งแต่ 20/05/2023; เปอร์เซ็นต์คอมมิชชั่นหรือระยะเวลาอาจเปลี่ยนตามประกาศล่วงหน้า</p><p><br></p><p><strong>3. สำหรับผู้เข้าร่วม</strong></p><p><br></p><p>ผู้แนะนำ A: ต้องยืนยันตัวตนและเชิญ B อย่างน้อยหนึ่งคนที่ยืนยันตัวตนสำเร็จ</p><p><br></p><p>ผู้ใต้สาย B, C, D: คือผู้ที่ถูกเชิญโดย A หรือเชิญกันต่อ; เมื่อพวกเขาฝากเงิน A จะได้รับคอมมิชชั่น</p><p><br></p><p><strong>4. กติกาการเข้าร่วม</strong></p><p><br></p><p><strong>โครงสร้างระดับ:</strong></p><p>ระดับ 1 (B โดยตรง): B ฝาก ≥ 1000 USD → A ได้คอมมิชชั่น 1%;</p><p>ระดับ 2 (C): C ฝาก ≥ 1000 USD → A ได้คอมมิชชั่น 0.5%;</p><p>ระดับ 3 (D): D ฝาก ≥ 1000 USD → A ได้คอมมิชชั่น 0.3%;</p><p>สนับสนุนสูงสุด 3 ระดับ</p><p><br></p><p><strong>ช่องทางและยอดขั้นต่ำ:</strong></p><p>รองรับทุกช่องทางฝาก (fiat หรือคริปโต) แต่ต้อง ≥ 1000 USD ต่อรายการเพื่อรับคอมมิชชั่น</p><p><br></p><p><strong>อัตราคอมมิชชั่น:</strong></p><p>ระดับ 1: 1.0% (เช่น B ฝาก 1000 USD → A ได้ 10 USD);</p><p><br></p><p>ระดับ 2: 0.5% (C ฝาก 1000 USD → A ได้ 5 USD);</p><p><br></p><p>ระดับ 3: 0.3% (D ฝาก 1000 USD → A ได้ 3 USD);</p><p><br></p><p><strong>การจ่ายคอมมิชชั่น:</strong></p><p>ระบบจะโอนคอมมิชชั่นภายใน 24 ชั่วโมงหลังเงินเข้าบัญชี;</p><p>ผู้ใช้ตรวจสอบแหล่งที่มาและเวลาใน “กระเป๋าของฉัน” → “รายละเอียดคอมมิชชั่น”</p><p><br></p><p>5. ตัวอย่างขั้นตอน:</p><p><br></p><p>A ล็อกอินแอป → “หน้าบุคคล” → “เชิญเพื่อน” → คัดลอกลิงก์/โค้ด;</p><p>A ส่งให้ B;</p><p>B ลงทะเบียน → ยืนยันตัวตน → ฝาก ≥ 1000 USD;</p><p>เมื่อเงื่อนไขตรง เงินเข้าระบบ ระบบคำนวณอัตโนมัติ: ยอดฝาก x 1% = คอมมิชชั่นสำหรับ A; โอนภายใน 24 ชั่วโมง;</p><p><br></p><p>หลังจาก B ยืนยันเสร็จ สามารถเชิญ C; หาก C ฝาก:</p><p>B ได้จากฝากของ C x 1%;</p><p>A ได้จากฝากของ C x 0.5%;</p><p><br></p><p>C เชิญ D; หาก D ฝาก:</p><p>C ได้จากฝาก D x 1%;</p><p>B ได้จากฝาก D x 0.5%;</p><p>A ได้จากฝาก D x 0.3%;</p><p><br></p><p><strong>6. การควบคุมความเสี่ยง & ข้อควรระวัง:</strong></p><p><br></p><p><strong>ป้องกันการประพฤติในทางที่ผิด:</strong></p><p>ผู้ใช้แต่ละคนไม่ควรทำธุรกรรมวนซ้ำ; ระบบจะตรวจสอบการฝากเล็ก ๆ ซ้ำ ๆ หรือถอนบ่อย และอาจยกเลิกคอมมิชชั่น;</p><p>หากพบการถอนเร็วหรือทำธุรกรรมถี่ ระบบอาจยกเลิกคอมมิชชั่น;</p><p><br></p><p><strong>เป็นไปตามกฎหมาย:</strong></p><p>หากพบความเสี่ยงฟอกเงินหรือถอนเงินผิดกฎหมาย แพลตฟอร์มมีสิทธิ์ระงับคอมมิชชั่นและแจ้งหน่วยงานกฎหมาย</p><p><br></p>',
        authRewardTxt: '<p><strong>ยืนยันตัวตน รับ 50 USD ทันที</strong></p><p><br></p><p>1. จุดประสงค์ของกิจกรรม</p><p><br></p><p>กลุ่มเป้าหมาย: ผู้ใช้ใหม่และเก่า (หากยังไม่ได้ยืนยันตัวตน) สามารถเข้าร่วมได้ โดยมุ่งเน้นให้ผู้ใช้ทำการยืนยันและยึดติดกับแพลตฟอร์ม รวมถึงกระตุ้นผู้ที่ลังเลเนื่องจากขั้นตอนยุ่งยาก</p><p>แนวคิดหลัก: ผ่านรางวัลเป็นเงินสด กระตุ้นให้ผู้ใช้ยืนยันตัวตน เพิ่มประสิทธิภาพการควบคุมความเสี่ยงและอัตราการทำ KYC ให้เป็นไปตามข้อกำหนด</p><p><br></p><p>2. ระยะเวลากิจกรรม</p><p><br></p><p>20/05/2023 – มีผลตลอดไป</p><p><br></p><p>3. สำหรับผู้เข้าร่วม</p><p><br></p><p>ผู้ใช้ใหม่: ลงทะเบียนครั้งแรกใน cryptorix และยืนยันตัวตนภายในช่วงโปรโมชั่น</p><p>ผู้ใช้เก่า: เคยลงทะเบียนก่อนหน้าแต่ยังไม่ได้ยืนยัน ต้องยืนยันภายในช่วงโปรเพื่อรับรางวัล</p><p><br></p><p>4. กติกาการยืนยันตัวตน</p><p><br></p><p>เงื่อนไข:</p><p>อัปโหลดรูปเอกสารชัดเจน (บัตรประชาชน/พาสปอร์ต/ใบขับขี่) ทั้งสองด้าน และรูปถ่ายครึ่งตัวถือเอกสาร;</p><p>ตรวจสอบใบหน้าต้องมีแสงสว่างเพียงพอ ไม่มีสิ่งบดบัง และผ่านระบบตรวจ Liveness;</p><p>ระบบใช้เวลาตรวจสอบไม่เกิน 24 ชั่วโมง;</p><p><br></p><p>5. รางวัล:</p><p>ผู้ใช้ทุกคนที่ยืนยันตัวตนภายในช่วงโปร (ทุกระดับ) จะได้รับ 50 USD;</p><p><br></p><p>การจ่ายรางวัล:</p><p>ระบบโอน 50 USD ไปยังบัญชี fiat-contract ภายใน 24 ชั่วโมงหลังยืนยัน; เมื่อทำธุรกรรมปกติครบ 10 ครั้ง จะสามารถถอนเงินได้;</p><p><br></p><p>หากข้อมูลไม่ครบหรือถูกปฏิเสธ ให้แก้ไขและยืนยันใหม่ก่อนจะรับรางวัล;</p><p><br></p><p>6. ตัวอย่างขั้นตอน:</p><p><br></p><p>ผู้ใช้ล็อกอินแอป → “ยืนยันตัวตน” → เริ่มขั้นตอน;</p><p>อัปโหลดรูปบัตรประชาชน/พาสปอร์ต/ใบขับขี่ ทั้งสองด้าน;</p><p>ระบบตรวจสอบอัตโนมัติ; หากไม่ผ่าน จะมีข้อความให้ทำใหม่;</p><p>เมื่อตรวจผ่าน ระบบจะโอน 50 USD ไปยังบัญชี fiat-contract ใน 24 ชั่วโมง;</p><p><br></p><p>7. การควบคุมความเสี่ยง & ข้อควรระวัง:</p><p><br></p><p><strong>ป้องกันการทุจริต:</strong></p><p>เอกสารแต่ละชิ้นรับรางวัลได้เพียงครั้งเดียว; หากจาก IP หรืออุปกรณ์เดียวกันอัปโหลดหลายเอกสาร ระบบจะควบคุมหรือตอบรับด้วยตนเอง;</p><p>หากพบเอกสารปลอมหรือปรับแต่งรูป ระบบจะปฏิเสธและระงับบัญชี;</p><p><br></p><p><strong>การคุ้มครองข้อมูล:</strong></p><p>แพลตฟอร์มยืนยันว่าเอกสารและข้อมูล biometrics จะใช้เฉพาะเพื่อ KYC และควบคุมความเสี่ยง ไม่เปิดเผยโดยไม่ได้รับอนุญาต;</p><p>หลังยืนยัน เอกสารและวิดีโอจะถูกเข้ารหัสและเก็บรักษาตามกฎหมาย;</p><p><br></p><p>&nbsp;</p>'
    },
    bill: {
        title: 'รายละเอียดการเงิน',
        audit: 'รอตรวจสอบ',
        success: 'สำเร็จ',
        refuse: 'ปฏิเสธ',
        recharge: 'เติมเงิน',
        recharge_currency: 'เติมเหรียญ',
        recharge_legal: 'ฝากเงินตราผันผวน',
        withdrawal: 'ถอนเงิน',
        withdrawal_currency: 'ถอนเหรียญ',
        cancel_withdrawal_currency: 'ยกเลิกการถอนเหรียญ',
        withdrawal_legal: 'ถอนเงินตราผันผวน',
        cancel_withdrawal_legal: 'ยกเลิกการถอนเงินตราผันผวน',
        transfer: 'โอนเงิน',
        usdt_contract_wallet: 'USDT สัญญา -> กระเป๋า',
        legal_contract_wallet: 'สัญญาเงินตราผันผวน -> กระเป๋า',
        coin_currency_wallet: 'สปอต -> กระเป๋า',
        wallet_usdt_contract: 'กระเป๋า -> USDT สัญญา',
        wallet_legal_contract: 'กระเป๋า -> สัญญาเงินตราผันผวน',
        wallet_coin_currency: 'กระเป๋า -> สปอต',
        finance_wallet: 'เงิน -> กระเป๋า',
        wallet_finance: 'กระเป๋า -> เงิน',
        usdt_contract_currency: 'สัญญา USDT -> สปอต',
        finance_currency: 'การเงิน -> สปอต',
        currency_usdt_contract: 'สปอต -> สัญญา USDT',
        currency_finance: 'สปอต -> การเงิน',
        legal_contract_currency: 'สัญญาเงินเฟียต -> สปอต',
        currency_legal_contract: 'สปอต -> สัญญาเงินเฟียต',
        recharge_reward: 'คอมมิชชั่นจากการเติมเงินของลูกทีม',
        auth_reward: 'รางวัลยืนยันตัวตน',
        flashcash: 'แลกเปลี่ยนด่วน',
        trade: 'การซื้อขาย',
        create_order: 'สร้างคำสั่ง',
        settlement_order: 'การชำระคำสั่ง',
        cancel_order: 'ยกเลิกคำสั่ง',
        finance_return: 'คืนเงินต้นการลงทุน',
        finance_income: 'ผลกำไรจากการลงทุน',
        other: 'อื่นๆ',
        commission_transfer: 'โอนคอมมิชชั่น',
        platform_gift: 'ของขวัญจากแพลตฟอร์ม',
        system_regulation: 'การเปลี่ยนแปลงยอดคงเหลือ',
        freeze_thaw: 'แช่แข็งละลาย',
        c2c_create_order: 'C2Cสร้างคำสั่ง',
        c2c_cancel_order: 'C2Cยกเลิกคำสั่ง',
        Currency: 'สกุลเงิน',
        type: 'ประเภท',
        SelectCurrency: 'เลือกสกุลเงิน',
        SelectType: 'เลือกประเภท',
        SelectDate: 'เลือกวันที่',
        to: 'ถึง',
        Contractfunds: 'เงินทุนสัญญา',
        Spotfunds: 'เงินทุนสปอต',
        Walletfunds: 'เงินทุนกระเป๋า',
        RechargeRecord: 'ประวัติการฝากเงิน',
        WithdrawalRecord: 'ประวัติการถอนเงิน',
        virtualcoin: 'เหรียญดิจิทัล',
        Legaltender: 'เงินตราผันผวน',
    },
    c2c: {
        limit: 'ขีดจำกัด',
        available: 'ใช้ได้',
        price: 'ราคาต่อหน่วย',
        needpay: 'คุณต้องชำระ',
        willreceive: 'คุณจะได้รับ',
        Insufficientlimit: 'ขีดจำกัดไม่เพียงพอ',
        Exceedinglimit: 'เกินขีดจำกัด',
        Exceedingavailable: 'เกินจำนวนที่ใช้ได้',
        balance: 'ยอดคงเหลือ',
        InsufficientBalance: 'ยอดคงเหลือไม่เพียงพอ',
        OrderHistory: 'ประวัติคำสั่งซื้อ',
        quantity: 'จำนวน',
        amountmoney: 'จำนวนเงิน',
        OrderNo: 'หมายเลขคำสั่งซื้อ',
        inprogress: 'กำลังดำเนินการ',
        Completed: 'เสร็จสิ้น',
        Cancelled: 'ยกเลิกแล้ว',
        all: 'ทั้งหมด',
        chat: 'แชท',
        picture: '[รูปภาพ]',
        Read: 'อ่านแล้ว',
        Unread: 'ยังไม่ได้อ่าน',
        inputTips: 'พิมพ์ข้อความของคุณที่นี่',
        send: 'ส่ง',
    },
    common: {
        title: 'ฟังก์ชั่นทั้งหมด',
        Depositcoins: 'ฝากเหรียญ',
        Rechargefiatcurrency: 'ฝากเงินตราผันผวน',
        Withdraw: 'ถอน',
        documentation: 'ติดตาม',
        Activecenter: 'ศูนย์กิจกรรม',
        Invitationforrebate: 'เชิญเพื่อรับส่วนลด',
        Detailsoffunds: 'รายละเอียดการเงิน',
        Positiondetails: 'รายละเอียดตำแหน่ง',
        Notice: 'ข้อมูล',
        Aboutus: 'เกี่ยวกับเรา',
        helpcenter: 'ศูนย์ช่วยเหลือ',
        customer: 'บริการลูกค้า',
        Cryptocurrencywithdrawal: 'ถอนเหรียญดิจิทัล',
        Fiatmoneywithdrawal: 'ถอนเงินตราผันผวน',
        DepositcoinsTips: 'กระบวนการง่าย รวดเร็วในการซื้อเหรียญ',
        RechargefiatcurrencyTips: 'เติม USD ผ่านช่องทางเงินตราเฟียต',
        USDTcontractTips: 'สัญญาหลากหลายประเภทที่ชำระด้วย USDT',
        FiatcurrencycontractTips: 'สัญญาหลากหลายประเภทที่ชำระด้วยเงินตราเฟียต',
        TransferTips: 'แลกเปลี่ยนเป็นสินทรัพย์ cryptocurrency ที่แตกต่างกันในคลิกเดียว',
        c2cTips: 'ซื้อขาย และขายสกุลเงินดิจิทัลผ่านความยืดหยุ่น',
    },
    forgotPass: {
        title: 'รีเซ็ตรหัสผ่าน',
        btn: 'ยืนยัน',
        Password: 'รหัสผ่านใหม่',
        placeholder: 'โปรดกรอกรหัสผ่านใหม่',
        success: 'ตั้งค่าเสร็จสิ้น',
    },
    finance: {
        financeAssetAmount: 'มูลค่าสินทรัพย์ทางการเงิน',
        financeAccount: 'บัญชีการเงิน',
        financefund: 'กองทุนการเงิน',
        financeProduct: 'ผลิตภัณฑ์ทางการเงิน',
        Applynow: 'สมัครเลย',
        term: 'ระยะเวลา',
        investment: 'จำนวนเงินลงทุน',
        Mininvestment: 'เงินลงทุนขั้นต่ำ',
        Maxinvestment: 'จำนวนเงินลงทุนสูงสุด',
        buyNum: 'จำนวนครั้งที่ซื้อ',
        Myincome: 'รายได้ของฉัน',
        Dailyearnings: 'รายได้รายวัน',
        yieldmaturity: 'ผลตอบแทนเมื่อครบกำหนด',
        timeaxis: 'เส้นเวลา',
        Subscriptiondate: 'วันที่สมัคร',
        valuedate: 'วันที่เริ่มรับดอกเบี้ย',
        duedate: 'วันครบกำหนด',
        Receiptdate: 'วันที่ได้รับเงิน',
        day: 'วัน',
        financeOrderList: 'ประวัติการลงทุน',
        interestrate: 'อัตราดอกเบี้ย',
        Revenueamount: 'จำนวนรายได้',
        Settlementamount: 'จำนวนเงินที่ชำระ',
        regularly: 'ประจำ',
        eecurrent: 'ออมทรัพย์',
        redemption: 'ไถ่ถอน',
        redemptionTips: 'ยืนยันการไถ่ถอนผลิตภัณฑ์การเงินนี้',
        loan: 'เงินกู้',
        LoanRange: 'ช่วงวงเงินกู้',
        LoanAmount: 'จำนวนเงินกู้',
        loanTerm: 'ระยะเวลากู้',
        Dailyinterestrate: 'อัตราดอกเบี้ยรายวัน',
        Totalinterest: 'ดอกเบี้ยรวม',
        Repaymentmethod: 'วิธีการชำระคืน',
        Repaymentofmaturity: 'ชำระคืนเงินต้นและดอกเบี้ยทั้งหมดเมื่อครบกำหนด',
        Estimatedreturn: 'ยอดชำระโดยประมาณ',
        Ihavereadandagree: 'ฉันได้อ่านและยอมรับ',
        LoanAgreement: 'สัญญาเงินกู้',
        Immediatelymoney: 'กู้เงินทันที',
        Minimumloanamount: 'จำนวนเงินกู้ขั้นต่ำ',
        Maximumloanamount: 'จำนวนเงินกู้สูงสุด',
        Applicationsuccessfulreview: 'ยื่นคำขอสำเร็จ รอการตรวจสอบจากระบบ',
        Loanrecords: 'ประวัติเงินกู้',
        Pendingreview: 'รอการตรวจสอบ',
        issued: 'จ่ายเงินแล้ว',
        Repaid: 'ชำระคืนแล้ว',
        Rejected: 'ถูกปฏิเสธ',
        LoanDate: 'วันที่กู้',
        AmountDue: 'จำนวนเงินที่ต้องชำระ',
        repayment: 'ชำระคืน',
        loanTTips: 'อนุมัติและโอนเงินรวดเร็ว สามารถเลือกช่วงเวลาการค้ำประกันได้หลายแบบ',
        homeAddress: 'ที่อยู่บ้านโดยละเอียด',
        homeAddressTips: 'กรุณากรอกที่อยู่บ้านโดยละเอียด',
        emergencyContact: 'ผู้ติดต่อฉุกเฉิน',
        emergencyContactTips: 'กรุณากรอกผู้ติดต่อฉุกเฉิน',
        emergencyPhone: 'หมายเลขโทรศัพท์มือถือผู้ติดต่อฉุกเฉิน',
        emergencyPhoneTips: 'กรุณากรอกหมายเลขโทรศัพท์มือถือผู้ติดต่อฉุกเฉิน',
        emergencyEmail: 'อีเมลผู้ติดต่อฉุกเฉิน',
        emergencyEmailTips: 'กรุณากรอกอีเมลผู้ติดต่อฉุกเฉิน',
        isHouse: 'คุณมีอสังหาริมทรัพย์เป็นของตนเองหรือไม่',
        houseImg: 'หากมีอสังหาริมทรัพย์ กรุณาอัปโหลดรูปหลักฐานความเป็นเจ้าของ',
        certImg: 'ด้านหน้าของเอกสาร (บัตรประชาชน/พาสปอร์ต/ใบขับขี่)',
        certImgTips: 'กรุณาอัปโหลดด้านหน้าของเอกสาร (บัตรประชาชน/พาสปอร์ต/ใบขับขี่)',
        certBackImg: 'ด้านหลังเอกสาร (บัตรประชาชน/พาสปอร์ต/ใบขับขี่)',
        certBackImgTips: 'กรุณาอัปโหลดด้านหลังเอกสาร (บัตรประชาชน/พาสปอร์ต/ใบขับขี่)',
        trustImg: 'ภาพหน้าจอคะแนนเครดิต',
        trustImgTips: 'กรุณาอัปโหลดภาพหน้าจอคะแนนเครดิต',
        yesTxt: 'ใช่',
        noTxt: 'ไม่',
        EstimatedReturn: 'ผลตอบแทนโดยประมาณ',
        seeDetail: 'ดูรายละเอียด',
        orderDetails: 'รายละเอียดคำสั่งซื้อ',
    },
    heel: {
        tips: 'โปรดรอ ~',
    },
    home: {
        optional: 'เลือกได้',
        HotList: 'รายการยอดนิยม',
        more: 'เพิ่มเติม',
        Capturetrading: 'คว้าโอกาสในการซื้อขาย',
        Exploreproducts: 'สำรวจผลิตภัณฑ์ของเรา',
        Contracttrading: 'ซื้อขายสัญญาล่วงหน้า',
        Spottrading: 'การบริหารการเงิน',
        ContracttradingTips: 'ผลิตภัณฑ์อนุพันธ์ที่ได้รับความนิยม รองรับเลเวอเรจสูงสุดถึง 100 เท่า รองรับทั้งสถานะซื้อและขาย ทำกำไรได้ทุกครั้งที่ตลาดมีความผันผวน',
        SpottradingTips: 'ต้นทุนต่ำ กำไรสูง ซื้อขายได้ทุกที่ทุกเวลา รองรับทั้งการซื้อและขาย ทำกำไรได้ทุกครั้งที่ตลาดมีความผันผวน',
        starttrading: 'เริ่มต้นซื้อขาย',
        Tradeanytime: 'ซื้อขายได้ทุกที่ทุกเวลา',
        Scandownload: 'สแกนเพื่อดาวน์โหลด',
        hundredmillion: 'ร้อยล้าน',
        thousand: 'หมื่น',
        year: 'ปี',
        transactionvolume: 'ปริมาณการซื้อขาย 24 ชั่วโมง',
        openinterest: 'สัญญาคงค้าง 24 ชั่วโมง',
        RegisteredUser: 'ผู้ใช้ที่ลงทะเบียน',
        Ensuresafetyfunds: 'รับประกันความปลอดภัยของเงินทุน',
        Reasonschoosingus: 'เหตุผลที่เลือกเรา',
        mobeginwith: 'ก่อตั้งเมื่อ',
        Topliquidity: 'สภาพคล่องชั้นนำ',
        Effectivelyusers: 'คุ้มครองสิทธิ์ของผู้ใช้อย่างมีประสิทธิภาพ',
        TradeNow: 'ซื้อขายทันที',
        Needhelp: 'ต้องการความช่วยเหลือ',
        helpcenter: 'ศูนย์ช่วยเหลือ',
        helpcenterTips: 'ให้ความช่วยเหลือเกี่ยวกับคำถามที่พบบ่อยและคำอธิบายเกี่ยวกับฟังก์ชันเฉพาะ',
        Learnmore: 'เรียนรู้เพิ่มเติม',
        Onlinecustomerservice: 'บริการลูกค้าออนไลน์',
        OnlinecustomerserviceTips: 'ให้บริการลูกค้าตลอด 24/7 พร้อมช่วยเหลือคุณทุกที่ทุกเวลา',
        PlatformAnnouncement: 'ประกาศแพลตฟอร์ม',
        PlatformAnnouncementTips: 'รับข่าวสารล่าสุดและข้อมูลการซื้อขายแบบเรียลไทม์',
        Starttradingnow: 'เริ่มต้นการซื้อขายคริปโตของคุณตอนนี้!',
        Trademillions: 'ซื้อขายบนแพลตฟอร์มที่ผู้ใช้หลายล้านคนไว้วางใจ',
        Storingbuyingcoins: 'เติมเงินหรือซื้อเหรียญ',
        product: 'ผลิตภัณฑ์',
        service: 'บริการ',
        guide: 'คู่มือ',
        agreedannouncement: 'ข้อตกลงและประกาศ',
        customerservice: 'บริการลูกค้า',
        Riskstatement: 'คำเตือนความเสี่ยง: การซื้อขายสินทรัพย์ดิจิทัลเป็นอุตสาหกรรมใหม่ที่มีศักยภาพสูง แต่เนื่องจากเป็นนวัตกรรมใหม่ จึงมีความเสี่ยงสูงเช่นกัน โดยเฉพาะในการซื้อขายแบบใช้เลเวอเรจ ซึ่งสามารถขยายทั้งกำไรและความเสี่ยงได้พร้อมกัน โปรดตรวจสอบให้แน่ใจว่าคุณเข้าใจอุตสาหกรรมนี้ รูปแบบการซื้อขายแบบใช้เลเวอเรจ และกฎเกณฑ์ที่เกี่ยวข้องก่อนเข้าร่วม และเราขอแนะนำให้คุณซื้อขายภายในขอบเขตความเสี่ยงที่คุณสามารถรับได้ การซื้อขายมีความเสี่ยง โปรดใช้ความระมัดระวัง!',
        topTips: 'บัญชีเดียวความเป็นไปได้ไม่สิ้นสุด',
        coin: 'การซื้อขายสปอต',
        coinTips: 'รวดเร็วและโปร่งใส เริ่มต้นการเดินทางซื้อขายสปอตของคุณได้ทุกที่ทุกเวลา',
    },
    login: {
        title: 'เข้าสู่ระบบ',
        Account: 'บัญชีผู้ใช้',
        Password: 'รหัสผ่าน',
        btn: 'เข้าสู่ระบบ',
        placeholder: 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
        placeholder1: 'กรุณากรอกรหัสผ่าน',
        ForgotPassword: 'ลืมรหัสผ่าน',
        noAccount: 'ยังไม่มีบัญชี?',
        Registration: 'สมัครสมาชิก',
        server: 'ติดต่อฝ่ายบริการลูกค้า',
        success: 'เข้าสู่ระบบสำเร็จ',
        checkedAgree: 'กรุณายอมรับข้อตกลงความเป็นส่วนตัวก่อน',
        rememberpassword: 'จดจำรหัสผ่าน',
        agreewith: 'ตกลง',
        PrivacyAgreement: 'ข้อตกลงความเป็นส่วนตัว',
    },
    market: {
        product: 'ผลิตภัณฑ์',
        Latestprice: 'ราคาล่าสุด',
        volume: 'ปริมาณการซื้อขาย',
        ChangeRatio: 'อัตราการเปลี่ยนแปลง',
        Addoptional: 'เพิ่มรายการโปรด',
        optional: 'รายการโปรด',
        market: 'ตลาด',
        Editselfselection: 'แก้ไขรายการโปรด',
        operate: 'การดำเนินการ',
        SelectAll: 'เลือกทั้งหมด',
        delete: 'ลบ',
        time: 'เวลา',
    },
    position: {
        title: 'รายละเอียดตำแหน่ง',
        totalassets: 'มูลค่าสินทรัพย์รวม',
        profitloss: 'กำไร/ขาดทุน',
        Holdingassets: 'สินทรัพย์ที่ถือ',
        margin: 'มาร์จิ้น',
        orderAmount: 'จำนวนคำสั่งซื้อ',
        availableassets: 'สินทรัพย์ที่สามารถใช้ได้',
        product: 'ผลิตภัณฑ์',
        direction: 'ทิศทาง',
        Entrustedprice: 'ราคาคำสั่ง',
        Entrustednum: 'จำนวนคำสั่ง',
        Currentprice: 'ราคาปัจจุบัน',
        Stoplossprice: 'ราคาหยุดขาดทุน',
        stopSurplusPrice: 'ราคาหยุดกำไร',
        Leverageratio: 'อัตราส่วนเลเวอเรจ',
        Entrustedtime: 'เวลาคำสั่ง',
        orderno: 'หมายเลขคำสั่ง',
        marketvalue: 'มูลค่าตลาด',
        SettlementPrice: 'ราคาชำระบัญชี',
        Settlementtime: 'เวลาชำระบัญชี',
        Settakeprofitloss: 'ตั้งค่าหยุดกำไร/หยุดขาดทุน',
        closeposition: 'ปิดตำแหน่ง',
        Position: 'คำสั่งที่ยังไม่ปิด',
        commission: 'คำสั่งประวัติ',
        Settlement: 'ประวัติการชำระบัญชี',
        Settingsuccessful: 'ตั้งค่าเสร็จสิ้น',
        Confirmclosingorder: 'ยืนยันการปิดคำสั่งนี้',
        Closingsuccessfully: 'ปิดตำแหน่งสำเร็จ',
        cancelorder: 'ยืนยันการยกเลิกคำสั่งนี้',
        Cancelsuccessfully: 'ยกเลิกสำเร็จ',
        status: 'สถานะ',
        changeRate: 'ค่าธรรมเนียม',
    },
    property: {
        title: 'รายละเอียดสินทรัพย์',
        totalassets: 'มูลค่าสินทรัพย์รวม',
        profitloss: 'กำไร/ขาดทุน',
        Holdingassets: 'สินทรัพย์ที่ถือ',
        margin: 'มาร์จิ้น',
        availableassets: 'สินทรัพย์ที่สามารถใช้ได้',
        investmentportfolio: 'พอร์ตการลงทุน',
        Recentincomesituation: 'สถานการณ์รายได้ล่าสุด',
        Seemore: 'ดูเพิ่มเติม',
        IncomeDetails: 'รายละเอียดรายได้',
    },
    recharge: {
        mixAmount: 'จำนวนเงินฝากขั้นต่ำ',
        subMsg: 'ส่งคำขอสำเร็จ กรุณารอการตรวจสอบ',
        amountMsg: 'กรุณากรอกจำนวนเงิน',
        VoucherMsg: 'กรุณาอัปโหลดหลักฐานการชำระเงิน',
        Depositcoins: 'ฝากเหรียญ',
        Rechargecurrency: 'สกุลเงินที่ฝาก',
        RechargecurrencyTips: 'ฝากเหรียญมากกว่า 200USDT จะได้รับการโอนเงินที่รวดเร็ว',
        Depositaddress: 'ที่อยู่การฝากเหรียญ',
        Rechargetoaccount: 'ฝากเข้าบัญชี',
        Walletaccount: 'บัญชีเงินฝาก',
        Rechargequantity: 'จำนวนการฝาก',
        Paymentvoucher: 'หลักฐานการชำระเงิน',
        Youneedtorecharge: 'คุณต้องทำการฝากเงิน',
        Rechargenow: 'ฝากเงินตอนนี้',
        Rechargefiatcurrency: 'ฝากเงินตราผันผวน',
        Topupfiatcurrency: 'เติมเงินตราผันผวน',
        paymentcurrency: 'สกุลเงินที่ชำระ',
        paymentcurrencyTips: 'ฝากเงินมากกว่า 200USD จะได้รับการโอนเงินที่รวดเร็ว',
        Fiatcontractaccount: 'บัญชีสัญญาเงินตราผันผวน',
        Rechargeamount: 'จำนวนเงินที่ฝาก',
        Youwillget: 'คุณจะได้รับ',
        network: 'เครือข่าย',
        notsupportedAddress: 'ที่อยู่ปัจจุบันไม่รองรับ',
        selectaccount: 'กรุณาเลือกบัญชี',
    },
    register: {
        title: 'สมัครสมาชิก',
        send: 'ส่งรหัสยืนยัน',
        Resend: 'ส่งใหม่',
        sendSuccess: 'ส่งสำเร็จ',
        PhoneNumber: 'หมายเลขโทรศัพท์มือถือ',
        Mailbox: 'อีเมล',
        Captcha: 'รหัสยืนยัน',
        Password: 'รหัสผ่าน',
        ConfirmPassword: 'ยืนยันรหัสผ่าน',
        PromoteCode: 'รหัสโปรโมท',
        OrgCode: 'รหัสองค์กร',
        btn: 'สมัครสมาชิก',
        placeholder0: 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
        placeholder1: 'กรุณากรอกรหัสผ่าน',
        placeholder2: 'กรุณากรอกรหัสผ่านยืนยัน',
        placeholder3: 'กรุณากรอก ID ผู้แนะนำ',
        placeholder4: 'กรุณากรอกรหัสยืนยัน',
        placeholder5: 'กรุณากรอกอีเมล',
        emaiError: 'รูปแบบอีเมลไม่ถูกต้อง',
        success: 'สมัครสมาชิกสำเร็จ',
        message: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
        message1: 'รหัสผ่านยืนยันต้องมีอย่างน้อย 6 ตัวอักษร',
        message2: 'รหัสผ่านทั้งสองไม่ตรงกัน',
        searchCountryMsg: 'กรุณากรอกประเทศหรือรหัสพื้นที่ในการค้นหา',
        haveAccount: 'มีบัญชีอยู่แล้ว?',
        goLogin: 'เข้าสู่ระบบ',
        titleTips: 'เริ่มจากการสมัครสมาชิก!',
        Invitationcode: 'รหัสเชิญ',
        Iagreewith: 'การสร้างบัญชีถือว่าฉันยอมรับ',
        and: 'และ',
    },
    safe: {
        SecuritySettings: 'การตั้งค่าความปลอดภัย',
        Accountsecurity: 'ความปลอดภัยบัญชี',
        phone: 'โทรศัพท์มือถือ',
        Notyetbound: 'ยังไม่ได้ผูก',
        mailbox: 'อีเมล',
        Loginpassword: 'รหัสผ่านเข้าสู่ระบบ',
        Fundcode: 'รหัสผ่านทางการเงิน',
        Settings: 'การตั้งค่า',
        Withdrawaladdressmanagement: 'การจัดการที่อยู่การถอน',
        Addwithdrawaladdress: 'เพิ่มที่อยู่การถอน',
        Withdrawalcurrency: 'สกุลเงินถอน',
        Withdrawaladdress: 'ที่อยู่การถอน',
        WithdrawaladdressTips: 'กรุณากรอกที่อยู่การถอน',
        remark: 'หมายเหตุ',
        confirm: 'ยืนยัน',
        Addedsuccessfully: 'เพิ่มสำเร็จ',
        Pleaseselectcurrency: 'กรุณาเลือกสกุลเงิน',
        Bindmailbox: 'ผูกบัญชีอีเมล',
        Bindmobilephone: 'ผูกหมายเลขโทรศัพท์มือถือ',
        ChangeLoginPassword: 'เปลี่ยนรหัสผ่านเข้าสู่ระบบ',
        Setfundpassword: 'ตั้งค่ารหัสผ่านทางการเงิน',
        BindmailboxTips: 'กรุณาผูกอีเมลก่อน ต้องการผูกหรือไม่?',
        Addnewaddress: 'เพิ่มที่อยู่ใหม่',
        Confirmdeleteaddress: 'ยืนยันการลบที่อยู่การถอนนี้',
    },
    share: {
        title: 'แชร์เพื่อหารายได้',
        commission: 'ค่าคอมมิชชั่น',
        Commissionrecord: 'ประวัติค่าคอมมิชชั่น',
        Commissiontransferout: 'โอนค่าคอมมิชชั่นออก',
        Transferoutrecord: 'ประวัติการโอนออก',
        Invitefriends: 'เชิญเพื่อน',
        Invitationrecord: 'ประวัติการเชิญ',
        Commissioncommission: 'ค่าคอมมิชชั่นจากการแนะนำ',
        ReferralCode: 'รหัสแนะนำ',
        Firstlevelmembers: 'สมาชิกระดับ 1',
        Secondlevelmembers: 'สมาชิกระดับ 2',
        Thirdlevelmembers: 'สมาชิกระดับ 3',
        Transferbalance: 'โอนเข้าสู่ยอดคงเหลือ',
        Confirmtransferout: 'ยืนยันการโอนออก',
        Transfersuccessful: 'การโอนออกสำเร็จ',
        amount: 'จำนวนเงินโอน',
        Transferfiaaccount: 'โอนเข้าสู่บัญชีสัญญาเงินตราผันผวน',
    },
    trade: {
        high: 'ราคาสูงสุด 24 ชั่วโมง',
        low: 'ราคาต่ำสุด 24 ชั่วโมง',
        vol: 'ปริมาณการซื้อขาย 24 ชั่วโมง',
        buy: 'ซื้อ',
        sell: 'ขาย',
        buyBtn: 'ซื้อ',
        sellBtn: 'ขาย',
        Present: 'คำสั่งราคาตลาด',
        Limit: 'คำสั่งราคาจำกัด',
        limitMsg: 'ราคา',
        markPriceMsg: 'ตามราคาที่ดีที่สุดในปัจจุบัน',
        num: 'จำนวน',
        zyzsSet: 'ตั้งค่าหยุดกำไร/หยุดขาดทุน',
        zyPrice: 'หยุดกำไร',
        zsPrice: 'หยุดขาดทุน',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: 'ตำแหน่ง',
        Viewalltransactions: 'ดูธุรกรรมทั้งหมด',
        product: 'ผลิตภัณฑ์',
        direction: 'ทิศทาง',
        Entrustedprice: 'ราคาคำสั่ง',
        Entrustednum: 'จำนวนคำสั่ง',
        Latestprice: 'ราคาล่าสุด',
        volume: 'ปริมาณการซื้อขาย',
        ChangeRatio: 'อัตราการเปลี่ยนแปลง',
        buyBtnConfirm: 'ยืนยันการซื้อ',
        sellBtnConfirm: 'ยืนยันการขาย',
        totalAmount: 'จำนวนเงิน',
        Margin: 'มาร์จิ้น',
        balance: 'ยอดคงเหลือ',
        buyLimtMsg: 'การเปิดสถานะยาวต้องกรอกราคาที่ต่ำกว่าราคาตลาด',
        sellLimtMsg: 'การเปิดสถานะสั้นต้องกรอกราคาที่สูงกว่าราคาตลาด',
        putNummsg: 'กรุณากรอกจำนวน',
        putLimitPriceMsg: 'กรุณากรอกราคาจำกัด',
        pleaseAuth: 'กรุณาทำการยืนยันตัวตนก่อน',
        orderSuccess: 'ทำการซื้อขายสำเร็จ',
        Fullwarehouse: 'เต็มคลัง',
        corkado: 'สามารถเปิดสถานะยาวได้',
        Kato: 'เปิดสถานะยาว',
        openable: 'สามารถเปิดสถานะสั้นได้',
        Openempty: 'เปิดสถานะสั้น',
        purchasable: 'สามารถซื้อได้',
        vendibility: 'สามารถขายได้',
        Orderconfirmation: 'ยืนยันการสั่งซื้อ',
        Averageopeningprice: 'ราคาเปิดเฉลี่ย',
        Marketprice: 'ราคาตลาด',
        Openingquantity: 'จำนวนการเปิดตำแหน่ง',
        Stoplossprice: 'ราคาหยุดขาดทุน',
        stopSurplusPrice: 'ราคาหยุดกำไร',
        Averageprice: 'ราคาเฉลี่ย',
        buyLimtMsg2: 'การซื้อสินค้าต้องกรอกราคาที่ต่ำกว่าราคาตลาด',
        sellLimtMsg2: 'การขายสินค้าต้องกรอกราคาที่สูงกว่าราคาตลาด',
        authTips: 'กรุณาทำการยืนยันตัวตนก่อน',
        profundity: 'ความลึก',
        deal: 'การซื้อขาย',
        contract: 'สัญญา',
        TradeNow: 'ทำการซื้อขายทันที',
        CloseTime: 'ตลาดฮิวจ์',
        buyUp: 'ซื้อขึ้น',
        buyDown: 'ซื้อลง',
        selectSeconds: 'เลือกเวลาหมดอายุ',
        buyNums: 'จำนวนเงินที่ซื้อ',
        minbuyNums: 'จำนวนซื้อขั้นต่ำ',
        incomeRates: 'อัตราผลตอบแทน',
        buySuccessTips: 'ซื้อสำเร็จ',
        secondNums: 'วินาที',
        simulatedTrading: 'การซื้อขายจำลอง',
    },
    upPassword: {
        title: 'เปลี่ยนรหัสผ่าน',
        oldPassword: 'รหัสผ่านเดิม',
        oldPasswordMsg: 'กรุณากรอกรหัสผ่านเดิม',
        newPassword: 'รหัสผ่านใหม่',
        newPasswordMsg: 'กรุณากรอกรหัสผ่านใหม่',
        twoPassword: 'ยืนยันรหัสผ่าน',
        twoPasswordMsg: 'กรุณากรอกยืนยันรหัสผ่าน',
        twoinputMsg: 'รหัสผ่านสองครั้งไม่ตรงกัน',
        passwordTypeMsg: 'รหัสผ่านต้องมีตัวเลข 6 หลัก',
        submsg: 'การเปลี่ยนแปลงสำเร็จ',
        btn: 'ยืนยันการเปลี่ยนแปลง',
    },
    user: {
        Avatarchange: 'เปลี่ยนรูปโปรไฟล์',
        Replacesuccessfully: 'เปลี่ยนสำเร็จ',
        authenticated: 'ได้รับการรับรองแล้ว',
        Notcertifiedyet: 'ยังไม่ได้รับการรับรอง',
        Invitefriends: 'เชิญเพื่อน',
        Activecenter: 'ศูนย์กิจกรรม',
        Identityauthentication: 'การยืนยันตัวตน',
        Completedverification: 'การยืนยันเสร็จสิ้น',
        Tobeverified: 'รอการยืนยัน',
        SecuritySettings: 'การตั้งค่าความปลอดภัย',
        Lang: 'เลือกภาษา',
        changeTheme: 'เปลี่ยนธีม',
        helpcenter: 'ศูนย์ช่วยเหลือ',
        Aboutus: 'เกี่ยวกับเรา',
        out: 'ออกจากระบบ',
        outmsg: 'ยืนยันการออกจากระบบ',
        trustscore: 'คะแนนความน่าเชื่อถือ',
    },
    welcome: {
        title1: 'สภาพคล่องของตลาดชั้นนำในอุตสาหกรรม',
        tips1: '99% ของคำสั่งซื้อจะดำเนินการในราคาสูงสุด',
        title2: '12 ปีแห่งความไว้วางใจ',
        tips2: 'ทำการซื้อขายสกุลเงินดิจิทัลได้ทุกที่ทุกเวลาในแพลตฟอร์มที่น่าเชื่อถือ',
        title3: 'สิทธิพิเศษสำหรับ VIP',
        tips3: 'กลายเป็น VIP และรับส่วนลดค่าธรรมเนียมในการซื้อขาย แลกเปลี่ยน และถอนเงิน',
        title4: '100,000USDT เงินทุนทดลองซื้อขาย',
        tips4: 'ฝึกซื้อขายโดยไม่มีความเสี่ยง',
        bnt1: 'สมัครรับ 10 USDT ทันที',
        bnt2: 'เข้าสู่ระบบ',
    },
    with: {
        Withdrawcurrency: 'ถอนเงิน',
        currencyofwithdrawal: 'สกุลเงินที่ถอน',
        Withdrawaladdress: 'ที่อยู่การถอน',
        Addwithdrawaladdress: 'เพิ่มที่อยู่การถอน',
        Withdrawalquantity: 'จำนวนการถอน',
        availablebalance: 'ยอดคงเหลือที่สามารถใช้ได้',
        WithdrawaladdressTips: 'ยังไม่ได้ตั้งค่าที่อยู่การถอนสำหรับสกุลเงินนี้ ต้องการตั้งค่าหรือไม่?',
        selectWithdrawaladdress: 'เลือกที่อยู่การถอน',
        Insufficientavailablebalance: 'ยอดคงเหลือไม่เพียงพอ',
        Withdrawingfiatcurrency: 'ถอนเงินตราผันผวน',
        Withdrawaloffiatcurrency: 'ถอนเงินตราผันผวน',
        Currentbalance: 'ยอดคงเหลือปัจจุบัน',
        Currencyreceived: 'สกุลเงินที่ได้รับ',
        WithdrawingfiatcurrencyTips: 'การถอนเงินมากกว่า 200USD จะได้รับการโอนที่รวดเร็ว',
        Withdrawalaccount: 'บัญชีถอนเงิน',
        Fiatcontractaccount: 'บัญชีสัญญาเงินตราผันผวน',
        Withdrawalamount: 'จำนวนเงินถอน',
        Youneedwithdrawmoney: 'คุณต้องการถอนเงิน',
        Youwillget: 'คุณจะได้รับ',
        Withdrawimmediately: 'ถอนทันที',
        mixAmount: 'จำนวนเงินถอนขั้นต่ำ ',
        subMsg: 'ส่งคำขอสำเร็จ กรุณารอการตรวจสอบ',
    },
}